import React, { Fragment, useEffect, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import "./headerFooter.scss";
import blackLogo from "../Assets/Images/zenceBlackLogo.svg";
import whiteLogo from "../Assets/Images/Zencelogo.svg";
import BookDemo from "../Component/Login/BookDemo";
import OutsideClickHandler from "react-outside-click-handler";

export default function Header(props) {
  const [show, setShow] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleoutSideClick = (text) => {
    setIsDropdownOpen(text);
  };

  return (
    <Fragment>
      <nav className="fixed-top navbar navbar-expand-lg navbar-light">
        <div className="container-fluid">
          <NavLink to="/" className="navbar-brand px-5">
            <img
              src={blackLogo}
              alt="Logo"
              className="d-inline-block logo align-text-top"
            />
          </NavLink>
         
           
            <ul className="navbar-nav ms-auto">
              <li className="nav-item right-menu">
                <a className="nav-link d-flex gap-4 align-middle">
                  <button
                    className="btn btn-book-demo roboto-regular"
                    type="submit"
                    onClick={() => handleShow()}>
                    GET A DEMO
                  </button>
                </a>
              </li>
            </ul>
         
        </div>
      </nav>
      <BookDemo showModal={show} handleCloseModal={handleClose} />
    </Fragment>
  );
}
